export const translations = {
  "app_title": {
    "FR": "ELUA",
    "EN": "ELUA",
    "ES": "ELUA"
  },
  "tagline_main": {
    "FR": "Résonne Juste. Résonne Toi.",
    "EN": "Resonate Right. Resonate You.",
    "ES": "Resuena Justo. Resuena Tú."
  },
  "tagline_sub": {
    "FR": "Reprends Ton Souffle Divin.",
    "EN": "Reclaim Your Divine Breath.",
    "ES": "Recupera Tu Aliento Divino."
  },
  "btn_individual_reading": {
    "FR": "Lecture Individuelle",
    "EN": "Individual Reading",
    "ES": "Lectura Individual"
  },
  "btn_relationship_square": {
    "FR": "Carré Relationnel",
    "EN": "Relationship Square",
    "ES": "Cuadrado Relacional"
  },
  "label_name": {
    "FR": "Prénom (optionnel)",
    "EN": "First Name (optional)",
    "ES": "Nombre (opcional)"
  },
  "label_birthdate": {
    "FR": "Date de Naissance",
    "EN": "Birth Date",
    "ES": "Fecha de Nacimiento"
  },
  "placeholder_day": {
    "FR": "Jour",
    "EN": "Day",
    "ES": "Día"
  },
  "placeholder_month": {
    "FR": "Mois",
    "EN": "Month",
    "ES": "Mes"
  },
  "placeholder_year": {
    "FR": "Année",
    "EN": "Year",
    "ES": "Año"
  },
  "btn_calculate": {
    "FR": "Découvrir ma Lecture",
    "EN": "Discover my Reading",
    "ES": "Descubrir mi Lectura"
  },
  "btn_calculate_loading": {
    "FR": "Calcul en cours...",
    "EN": "Calculating...",
    "ES": "Calculando..."
  },
  "footer_text": {
    "FR": "Explorez votre chemin à travers les fréquences vibratoires de votre date de naissance",
    "EN": "Explore your path through the vibratory frequencies of your birth date",
    "ES": "Explora tu camino a través de las frecuencias vibratorias de tu fecha de nacimiento"
  },
  "title_square": {
    "FR": "Carré Relationnel ELUA",
    "EN": "ELUA Relationship Square",
    "ES": "Cuadrado Relacional ELUA"
  },
  "subtitle_square": {
    "FR": "Découvrez la fréquence vibratoire de votre lien",
    "EN": "Discover the vibratory frequency of your bond",
    "ES": "Descubre la frecuencia vibratoria de tu vínculo"
  },
  "label_person1": {
    "FR": "Personne 1",
    "EN": "Person 1",
    "ES": "Persona 1"
  },
  "label_person2": {
    "FR": "Personne 2",
    "EN": "Person 2",
    "ES": "Persona 2"
  },
  "btn_discover_link": {
    "FR": "Découvrir votre lien",
    "EN": "Discover your bond",
    "ES": "Descubrir su vínculo"
  },
  "square_title": {
    "FR": "Carré ELUA",
    "EN": "ELUA Square",
    "ES": "Cuadrado ELUA"
  },
  "nodal_point": {
    "FR": "Point Nodal — Cœur Vibratoire du Lien",
    "EN": "Nodal Point — Vibratory Heart of the Bond",
    "ES": "Punto Nodal — Corazón Vibratorio del Vínculo"
  },
  "frequency": {
    "FR": "Fréquence",
    "EN": "Frequency",
    "ES": "Frecuencia"
  },
  "explore_square": {
    "FR": "Explorer le Carré",
    "EN": "Explore the Square",
    "ES": "Explorar el Cuadrado"
  },
  "axis_mental": {
    "FR": "Axe Mental",
    "EN": "Mental Axis",
    "ES": "Eje Mental"
  },
  "axis_soul": {
    "FR": "Axe Âme (Point Nodal)",
    "EN": "Soul Axis (Nodal Point)",
    "ES": "Eje Alma (Punto Nodal)"
  },
  "axis_manifestation": {
    "FR": "Axe Manifestation",
    "EN": "Manifestation Axis",
    "ES": "Eje Manifestación"
  },
  "aligned": {
    "FR": "Aligné",
    "EN": "Aligned",
    "ES": "Alineado"
  },
  "non_aligned": {
    "FR": "Non-Aligné",
    "EN": "Non-Aligned",
    "ES": "No Alineado"
  },
  "teaching": {
    "FR": "Enseignement",
    "EN": "Teaching",
    "ES": "Enseñanza"
  },
  "poles_aligned": {
    "FR": "Pôles Alignés",
    "EN": "Aligned Poles",
    "ES": "Polos Alineados"
  },
  "poles_non_aligned": {
    "FR": "Pôles Non-Alignés",
    "EN": "Non-Aligned Poles",
    "ES": "Polos No Alineados"
  },
  "teaching_link": {
    "FR": "Enseignement du Lien",
    "EN": "Teaching of the Bond",
    "ES": "Enseñanza del Vínculo"
  },
  "deep_reading_title": {
    "FR": "Lecture Approfondie",
    "EN": "In-Depth Reading",
    "ES": "Lectura Profunda"
  },
  "deep_reading_desc": {
    "FR": "Pour une analyse complète et personnalisée de votre carré relationnel avec les experts ELUA.",
    "EN": "For a complete and personalized analysis of your relationship square with ELUA experts.",
    "ES": "Para un análisis completo y personalizado de su cuadrado relacional con los expertos ELUA."
  },
  "btn_request_reading": {
    "FR": "Demander une Lecture Détaillée",
    "EN": "Request a Detailed Reading",
    "ES": "Solicitar una Lectura Detallada"
  },
  "disclaimer_square": {
    "FR": "Le carré relationnel ELUA ne prédit jamais l'amour ni la compatibilité.\nIl révèle la vibration du lien, les potentiels d'élévation,\net les zones à conscientiser entre deux âmes.",
    "EN": "The ELUA relationship square never predicts love or compatibility.\nIt reveals the vibration of the bond, the potentials for elevation,\nand the areas to be aware of between two souls.",
    "ES": "El cuadrado relacional ELUA nunca predice el amor ni la compatibilidad.\nRevela la vibración del vínculo, los potenciales de elevación,\ny las áreas a concientizar entre dos almas."
  },
  "signature_elua": {
    "FR": "Résonne Juste. Résonne Toi. — ELUA",
    "EN": "Resonate Right. Resonate You. — ELUA",
    "ES": "Resuena Justo. Resuena Tú. — ELUA"
  },
  "contact_title": {
    "FR": "Demande de Lecture Approfondie",
    "EN": "Request for In-Depth Reading",
    "ES": "Solicitud de Lectura Profunda"
  },
  "contact_subtitle": {
    "FR": "Contactez-nous pour une analyse numérologique détaillée et personnalisée",
    "EN": "Contact us for a detailed and personalized numerological analysis",
    "ES": "Contáctenos para un análisis numerológico detallado y personalizado"
  },
  "contact_form_title": {
    "FR": "Formulaire de Contact",
    "EN": "Contact Form",
    "ES": "Formulario de Contacto"
  },
  "label_fullname": {
    "FR": "Nom complet",
    "EN": "Full Name",
    "ES": "Nombre Completo"
  },
  "label_email": {
    "FR": "Email",
    "EN": "Email",
    "ES": "Correo Electrónico"
  },
  "label_phone": {
    "FR": "Téléphone (optionnel)",
    "EN": "Phone (optional)",
    "ES": "Teléfono (opcional)"
  },
  "label_message": {
    "FR": "Message / Questions",
    "EN": "Message / Questions",
    "ES": "Mensaje / Preguntas"
  },
  "placeholder_message": {
    "FR": "Décrivez votre demande de lecture approfondie, les aspects spécifiques que vous souhaitez explorer, ou toute question sur votre lecture numérologique",
    "EN": "Describe your request for in-depth reading, the specific aspects you wish to explore, or any questions about your numerological reading",
    "ES": "Describa su solicitud de lectura profunda, los aspectos específicos que desea explorar o cualquier pregunta sobre su lectura numerológica"
  },
  "btn_send": {
    "FR": "Envoyer la demande",
    "EN": "Send Request",
    "ES": "Enviar Solicitud"
  },
  "btn_sending": {
    "FR": "Envoi en cours...",
    "EN": "Sending...",
    "ES": "Enviando..."
  },
  "btn_back": {
    "FR": "Retour",
    "EN": "Back",
    "ES": "Volver"
  },
  "btn_home": {
    "FR": "Accueil",
    "EN": "Home",
    "ES": "Inicio"
  },
  "mental": {
    "FR": "Mental",
    "EN": "Mind",
    "ES": "Mental"
  },
  "soul": {
    "FR": "Âme",
    "EN": "Soul",
    "ES": "Alma"
  },
  "manifestation": {
    "FR": "Manifestation",
    "EN": "Manifestation",
    "ES": "Manifestación"
  },
  "btn_advanced_version": {
    "FR": "Version Avancée (Diagonales)",
    "EN": "Advanced Version (Diagonals)",
    "ES": "Versión Avanzada (Diagonales)"
  },
  "diag_montante": {
    "FR": "Diagonale Montante",
    "EN": "Ascending Diagonal",
    "ES": "Diagonal Ascendente"
  },
  "diag_descendante": {
    "FR": "Diagonale Descendante",
    "EN": "Descending Diagonal",
    "ES": "Diagonal Descendente"
  },
  "diag_petite_1": {
    "FR": "Petite Diagonale 1",
    "EN": "Small Diagonal 1",
    "ES": "Diagonal Pequeña 1"
  },
  "diag_petite_2": {
    "FR": "Petite Diagonale 2",
    "EN": "Small Diagonal 2",
    "ES": "Diagonal Pequeña 2"
  },
  "error_required_fields": {
    "FR": "Veuillez remplir tous les champs obligatoires",
    "EN": "Please fill all required fields",
    "ES": "Por favor complete todos los campos obligatorios"
  },
  "success_contact": {
    "FR": "Votre demande a été envoyée avec succès !",
    "EN": "Your request has been sent successfully!",
    "ES": "¡Su solicitud ha sido enviada con éxito!"
  },
  "error_generic": {
    "FR": "Une erreur s'est produite",
    "EN": "An error occurred",
    "ES": "Ocurrió un error"
  },
  "disclaimer_title": {
    "FR": "🧿 Disclaimer ELUA — Lecture Globale",
    "EN": "🧿 ELUA Disclaimer — Global Reading",
    "ES": "🧿 Disclaimer ELUA — Lectura Global"
  },
  "disclaimer_text": {
    "FR": "La lecture que vous allez recevoir est une vision globale issue de la méthode ELUA. Elle révèle des dynamiques vibratoires, des tendances mentales, d'âme et de manifestation. Elle ne prédit pas l'avenir, ne remplace aucune décision personnelle et ne définit pas une compatibilité amoureuse. ELUA éclaire — vous choisissez la direction.",
    "EN": "The reading you are about to receive is a global vision from the ELUA method. It reveals vibratory dynamics, mental, soul and manifestation tendencies. It does not predict the future, does not replace any personal decision and does not define romantic compatibility. ELUA illuminates — you choose the direction.",
    "ES": "La lectura que va a recibir es una visión global del método ELUA. Revela dinámicas vibratorias, tendencias mentales, del alma y de manifestación. No predice el futuro, no reemplaza ninguna decisión personal y no define compatibilidad amorosa. ELUA ilumina — usted elige la dirección."
  },
  "disclaimer_accept": {
    "FR": "J'ai compris, continuer",
    "EN": "I understand, continue",
    "ES": "Entiendo, continuar"
  },
  "contact_direct_title": {
    "FR": "Contact Direct",
    "EN": "Direct Contact",
    "ES": "Contacto Directo"
  },
  "contact_email_label": {
    "FR": "📩 Email :",
    "EN": "📩 Email:",
    "ES": "📩 Email:"
  },
  "contact_sms_label": {
    "FR": "📱 SMS uniquement :",
    "EN": "📱 SMS only:",
    "ES": "📱 SMS solamente:"
  },
  "btn_copy_email": {
    "FR": "Copier l'adresse",
    "EN": "Copy address",
    "ES": "Copiar dirección"
  },
  "btn_send_sms": {
    "FR": "Envoyer un SMS",
    "EN": "Send SMS",
    "ES": "Enviar SMS"
  },
  "email_copied": {
    "FR": "Email copié !",
    "EN": "Email copied!",
    "ES": "¡Email copiado!"
  },
  "contact_or": {
    "FR": "ou",
    "EN": "or",
    "ES": "o"
  },
  "testimonials_title": {
    "FR": "Livre d'Or",
    "EN": "Guestbook",
    "ES": "Libro de Oro"
  },
  "testimonials_subtitle": {
    "FR": "Partagez votre expérience avec ELUA",
    "EN": "Share your experience with ELUA",
    "ES": "Comparte tu experiencia con ELUA"
  },
  "testimonials_form_title": {
    "FR": "Laissez votre témoignage",
    "EN": "Leave your testimonial",
    "ES": "Deja tu testimonio"
  },
  "testimonials_name_label": {
    "FR": "Prénom",
    "EN": "First Name",
    "ES": "Nombre"
  },
  "testimonials_name_placeholder": {
    "FR": "Votre prénom",
    "EN": "Your first name",
    "ES": "Tu nombre"
  },
  "testimonials_text_label": {
    "FR": "Votre témoignage",
    "EN": "Your testimonial",
    "ES": "Tu testimonio"
  },
  "testimonials_text_placeholder": {
    "FR": "Partagez votre expérience avec ELUA...",
    "EN": "Share your experience with ELUA...",
    "ES": "Comparte tu experiencia con ELUA..."
  },
  "testimonials_rating_label": {
    "FR": "Votre note",
    "EN": "Your rating",
    "ES": "Tu calificación"
  },
  "testimonials_submit_btn": {
    "FR": "Envoyer mon témoignage",
    "EN": "Submit my testimonial",
    "ES": "Enviar mi testimonio"
  },
  "testimonials_success": {
    "FR": "Merci pour votre témoignage ! Il sera publié après validation.",
    "EN": "Thank you for your testimonial! It will be published after validation.",
    "ES": "¡Gracias por tu testimonio! Será publicado después de la validación."
  },
  "testimonials_error": {
    "FR": "Une erreur est survenue. Veuillez réessayer.",
    "EN": "An error occurred. Please try again.",
    "ES": "Ocurrió un error. Por favor, inténtalo de nuevo."
  },
  "testimonials_what_say": {
    "FR": "Ce qu'ils en pensent",
    "EN": "What they think",
    "ES": "Lo que piensan"
  },
  "testimonials_no_testimonials": {
    "FR": "Aucun témoignage pour le moment. Soyez le premier à partager votre expérience !",
    "EN": "No testimonials yet. Be the first to share your experience!",
    "ES": "Aún no hay testimonios. ¡Sé el primero en compartir tu experiencia!"
  }
};
